function initializeSocialShareContentBlock(): void {
  const socialShareElements = document.querySelectorAll('.social-share-content-block');
  const pageUrl = window.location.href;
  const pageTitle = document.title;
  const linkValues = {
    '.socialShareBoxPrint': 'javascript:window.print()',
    '.socialShareBoxEmail': `mailto:Subject=${encodeURIComponent(pageTitle)}&body=${encodeURIComponent(pageUrl)}`,
    '.socialShareBoxFacebook': `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`,
    '.socialShareBoxTwitter': `https://twitter.com/home?status=Learn%20about%20the%20%3A%20${encodeURIComponent(pageUrl)}`
  }
  socialShareElements.forEach((element) => {
    for (const [selector, url] of Object.entries(linkValues)) {
      const linkElement = element.querySelector(selector) as HTMLAnchorElement;
      if (linkElement) {
        linkElement.href = url;
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeSocialShareContentBlock();
});
